
import { getCurrentDubaiDate } from '../../../functions/agent/date/getCurrentDubaiDate'
import { toUTCWithOffset } from '../../../functions/agent/date/toUTCWithOffset'
import { getErrorss } from '../../../functions/errors/GetErrors'
import { getQueryCurrentUser } from '../../../functions/shared/api/queries/getQueryCurrentUser'
import { subtractDays } from '../../../functions/shared/date/subtractDays'
import { strapiSendNotify } from '../../../functions/shared/notify-helpers/strapiSendNotify'
import { ACCESS_KEY, urlAPI, USER_AREAS_EXTEND_COUNT, USER_CHOOSE_EXTEND_AREA, USER_ID_KEY } from '../../../urls'
import { setIsExtend, setUnitIDnotEnoughAreaForAdvertise } from '../../slices/advertisesSlice'
import { setWhatIsNotThereArea } from '../../slices/areasSlice'
import { dataFetchingFinish, dataFetchingStart, setButtonDriverExtendLocation } from '../../slices/modalSlice'
import { userFetchingSuccess, type ISettings } from '../../slices/userSlice'
import { type AppDispatch, type RootState } from '../../store'
import { createSubscriptionAgent } from '../subscriptionsActions/createSubscriptionAgent'
import { fetchUser } from '../userActions'

export const updateAreasForBricksPay = (formValues: any) => async (dispatch: AppDispatch, getState: () => RootState) => {

    const jwt = window.localStorage.getItem(ACCESS_KEY)
    const userID = window.localStorage.getItem(USER_ID_KEY)
    try {
        dispatch(dataFetchingStart())

        const currentUser = getState().user.currentUser

        const userSettings = (currentUser.Settings as ISettings[] | null)?.at(0)
        // const actualUser =   getState().areas.extendAreas
        const currentDubaiDate = getCurrentDubaiDate()

        const afterMonth = toUTCWithOffset(currentDubaiDate, -43200)
        const afterMonthMinusThreeDays = toUTCWithOffset(subtractDays(currentDubaiDate, 3), -43200)

        const storageCountAreasExtend = window.localStorage.getItem(USER_AREAS_EXTEND_COUNT)
        const countPack = (storageCountAreasExtend as string).split(' - ')[1]
 
        const createOrder = await dispatch(createSubscriptionAgent(`pack_areas_${countPack}`, undefined, { isTestMode: process.env.REACT_APP_IS_DEV === 'true', selectedPeriod: '' , areas : getState().areas.extendAreas }))

        //   dispatch(userSlice.actions.userUpdate(actualUser as User))
        if (createOrder?.isSuccessful === true) {
            window.localStorage.removeItem(USER_AREAS_EXTEND_COUNT)
            window.localStorage.removeItem(USER_CHOOSE_EXTEND_AREA)
            dispatch(setButtonDriverExtendLocation(false))
            dispatch(setIsExtend(false))
            dispatch(setUnitIDnotEnoughAreaForAdvertise(undefined))
            dispatch(setWhatIsNotThereArea(null))
            await dispatch(fetchUser(true))

            
            const bodyNotify = {
                mode: 'publish',
                RuleID: undefined,
                User: Number(userID),
                Text: 'Attention,area extension!',
                Type: 'Mobile',
                RuleData: getState().areas.extendAreas,
                publishedAt: null
            }
            await strapiSendNotify({
                ...bodyNotify,
                executeAt: afterMonth,
                Rule: 'user-area-extend'
            })

            await strapiSendNotify({
                ...bodyNotify,
                executeAt: afterMonthMinusThreeDays,
                Rule: 'user-area-extend-headsup'
            })

                  
            dispatch(dataFetchingFinish())
            return {  textNavigate: formValues.redirect , isSuccessful: true, textNotification: '' }
        }
      
    } catch (error) {
        console.log(error)
        dispatch(dataFetchingFinish())
    }
}


